import {GameStateEnums} from '../../../../../../shared/GameEnums'
import {UIGameManager} from '../../UIGameManager'
import {UIHoverActionController} from '../../ui_game_hover_actions/UIHoverActionController'
import {UIGameMechanic} from '../../UIGameEventController'
import {UIGameMapTileEdgeHoverController} from './UIGameMapTileEdgeHoverController'
import {UIGameMapTileCornerHoverController} from './UIGameMapTileCornerHoverController'
import {ActionState, TurnState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {CardExchangeFormat} from '@colonist/game-card-types'

export interface MapHoverController {
    registerHoverAction(hoverAction: UIHoverActionController): void
    onHoverStateChange(isHoverStateActive: boolean): void
    onHoverHighlightClick(): void
    onHoverHighlightCancellation(): void
}

export class UIGameMapHoverController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private isHoverStateActive: boolean
    private readonly tileEdgeHoverController: UIGameMapTileEdgeHoverController
    private readonly tileCornerHoverController: UIGameMapTileCornerHoverController

    constructor(uiGameManager: UIGameManager, shouldHighlightOnlyOnHover: boolean) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.isHoverStateActive = false
        this.tileEdgeHoverController = new UIGameMapTileEdgeHoverController(uiGameManager, shouldHighlightOnlyOnHover)
        this.tileCornerHoverController = new UIGameMapTileCornerHoverController(uiGameManager, shouldHighlightOnlyOnHover)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.GameStateUpdated:
            case UIGameEventEnums.DiceStateUpdated:
            case UIGameEventEnums.BeginnerModeActionUpdated:
            case UIGameEventEnums.FinishedBuildingGame:
            case UIGameEventEnums.PlayerControllerStateUpdated:
            case UIGameEventEnums.BeginnerModeInteractWithGuide:
                this.updateHoverState(); break
            case UIGameEventEnums.ExchangeCards: this.onExchangeCards(data); break
            default: break
        }
    }

    onHoverHighlightClick() {
        this.tileEdgeHoverController.onHoverHighlightClick()
        this.tileCornerHoverController.onHoverHighlightClick()
    }

    onClickInvisibleBackground() {
        this.tileEdgeHoverController.onClickInvisibleBackground()
        this.tileCornerHoverController.onClickInvisibleBackground()
    }

    onHoverHighlightCancellation() {
        this.tileEdgeHoverController.onHoverHighlightCancellation()
        this.tileCornerHoverController.onHoverHighlightCancellation()
    }

    onHoverStateChange() {
        this.tileEdgeHoverController.onHoverStateChange(this.isHoverStateActive)
        this.tileCornerHoverController.onHoverStateChange(this.isHoverStateActive)
    }

    private updateHoverState() {
        const updatedHoverState = this.isHoverStateUpdated()
        if(updatedHoverState == this.isHoverStateActive) return
        this.isHoverStateActive = updatedHoverState
    }

    private isHoverStateUpdated(): boolean {
        const validActionStates = [ActionState.None]
        if(this.uiGameManager.gameController.currentStateValidator.isSomePlayerInActionState(ActionState.SelectCardsToDiscard) == true) return false
        if(!this.uiGameManager.gameController.currentStateValidator.currentTurnPlayers.includes(this.uiGameManager.gameController.myColor)) return false
        if(this.uiGameManager.gameController.diceState.diceThrown == false) return false
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.GameEnd) return false
        if(!validActionStates.includes(this.uiGameManager.gameController.currentStateValidator.getPlayerActionState(this.uiGameManager.gameController.myColor))) return false

        return true
    }

    private onExchangeCards(data: CardExchangeFormat) {
        const amIExchangingCards = data.givingPlayer == this.uiGameManager.gameController.myColor || data.receivingPlayer == this.uiGameManager.gameController.myColor
        if(!amIExchangingCards) return

        this.onClickInvisibleBackground()
    }

    registerTileEdgeHoverAction(hoverAction: UIHoverActionController) {
        this.tileEdgeHoverController.registerHoverAction(hoverAction)
    }

    registerTileCornerHoverAction(hoverAction: UIHoverActionController) {
        this.tileCornerHoverController.registerHoverAction(hoverAction)
    }
}
